import { colorPrefix } from './_variables/colors';
import { lightThemeColors } from './theme-colors/light';
import { IColorMap } from './types';

export default {
  extend: {
    fontFamily: {
      sans: ['Open Sans', 'sans-serif'],
    },
    colors: Object.keys(lightThemeColors).reduce<IColorMap>(
      (acc, key) => {
        acc[key] = `var(${colorPrefix}${key})`;
        return acc;
      },
      {
        gray0: '#ffffff',
        gray1: '#fafafa',
        gray2: '#f5f5f5',
        gray3: '#f0f0f0',
        gray4: '#d9d9d9',
        gray5: '#bfbfbf',
        gray6: '#8c8c8c',
        gray7: '#595959',
        gray8: '#434343',
        gray9: '#262626',
        gray10: '#1f1f1f',
        gray11: '#141414',
        gray12: '#000000',
        primaryGray: '#999999',
      },
    ),
    fontSize: {
      '1': '9px',
      '2': '11px',
      '3': '12px',
      '4': '14px',
      '5': '16px',
      '6': '20px',
      '7': '24px',
    },
    spacing: {
      1: '4px',
      2: '8px',
      3: '12px',
      4: '16px',
      5: '20px',
      6: '24px',
      7: '32px',
    },
    borderRadius: {
      1: '2px',
      2: '4px',
      3: '6px',
      4: '8px',
      5: '24px',
      6: '100%',
    },
    screens: {
      xxs: '300px', // extra small mobile
      xs: '380px', // small mobile
      sm: '429px', // general mobile
      tb: '650px', // small tablet
      md: '768px', // tablet
      lg: '900px', // desktop
      xl: '1280px', // large desktop
    },
  },
};
